{
  "archived_Desc_Key": "We helpen je graag verder via deze pagina",
  "archived_Title_Key": "Dit document is gearchiveerd.",
  "carousel_Text_Key": "Kunnen we je verder helpen?",
  "click_prompt_Text_Key": "Kliek hier",
  "close_Text_Key": "Sluiten",
  "customerService_Text_Key": "Klantenservice",
  "error_Text_Key": "Oeps, er ging iets mis",
  "faq": "Veelgestelde vragen",
  "feedback_Option1_Text_Key": "Ik begrijp de tekst niet of deze is verwarrend",
  "feedback_Option2_Text_Key": "De tekst is niet relevant voor mijn vraag",
  "feedback_Option3_Text_Key": "De tekst is relevant, maar niet nuttig voor mij",
  "feedback_Option4_Text_Key": "De tekst is te lang of te kort ",
  "feedback_Question_1_Text_Key": "Welke specifieke onderdelen van onze artikelen vind je niet nuttig of niet behulpzaam?",
  "feedback_Rec_Text_Key": "Bedankt for je feedback!",
  "feedback_Text_Key": "Vond je dit nuttig?",
  "here_Text_Key": "via deze pagina",
  "knowledge_Text_Key": "Kennis",
  "link_prod_error_Text_Key": "https://ikea.marat.qd.je/nl/nl/customer-service/track-manage-order/",
  "loading_Text_Key": "Laden",
  "market_Name_Key": "Nederland",
  "modal_button_Close_Text_Key": "Sluiten",
  "negative_feedback_Text_Key": "Het spijt ons dat je niet het antwoord hebt gekregen dat je zocht, wil je ons helpen om dit te verbeteren?",
  "no_results_Text_Key": "Geen resultaten gevonden voor: {{query}}",
  "product_error_Text_Key": "Deze zoekbalk is voor ondersteunende informatie. Voor artikelnummers, probeer te zoeken in de bovenste zoekbalk op IKEA.nl. Zoek je naar informatie over je bestelling?",
  "read_more_button_Text_Key": "Lees meer",
  "results_Text_Key": "{{number}} resultaat/resultaten gevonden voor: {{query}}",
  "retrieving_Text_Key": "Laden",
  "searchbar_Text_Key": "Zoek",
  "searching_Text_Key": "Zoeken...",
  "showLess_Text_Key": "Lees minder",
  "showMore_Text_Key": "Lees meer",
  "spellcheck_Text_Key": "Controleer de spelling of gebruik andere zoektermen",
  "submit_Text_Key": "Stuur  in",
  "try_again_Text_Key": "Probeer het later nog een keer"
}